/**
 * @desc: 筛选条件继承全局状态管理
 *
 * 用于页面跳转时在来源页保存继承的筛选条件值的来源页面
 * 用于页面跳转时在来源页保存需要继承的筛选条件值，
 */

import type { Action, Reducer } from 'umi';

export const FILTER_INHERIT_NAMESPACE = 'intelligence_filter_inherit';

export interface IFilterInheritState {
  inheritedPageId: string;
  inheritedValues: IRecord;
}

type ISaveInheritedStateAction = Action<'saveInheritedState'> & { payload: IFilterInheritState };

export interface IFilterInheritModel {
  namespace: string;
  state: IFilterInheritState;
  reducers: {
    saveInheritedState: Reducer<IFilterInheritState, ISaveInheritedStateAction>;
    clearInheritedState: Reducer<IFilterInheritState>;
  };
}

export const DEFAULT_FILTER_INHERIT_STATE: IFilterInheritState = {
  inheritedPageId: '',
  inheritedValues: {},
};

const FilterInheritModel: IFilterInheritModel = {
  namespace: FILTER_INHERIT_NAMESPACE,
  state: DEFAULT_FILTER_INHERIT_STATE,
  reducers: {
    saveInheritedState(state, action) {
      const payload = action?.payload;
      return {
        ...state,
        inheritedPageId: payload?.inheritedPageId || '',
        inheritedValues: payload?.inheritedValues || {},
      };
    },
    clearInheritedState(state) {
      return {
        ...state,
        ...DEFAULT_FILTER_INHERIT_STATE,
      };
    },
  },
};

export default FilterInheritModel;
